import { useTranslation } from "react-i18next";
import "./accountlist.scss";
import MainLayout from "../../../layouts/layout";
import { Breadcrumb, Button, Table } from "antd";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Content } from "antd/es/layout/layout";
import { NotFound } from "../../../../sources/svg/svg";
const Accountlist = () => {
  const [t] = useTranslation("global");
  const nav = useNavigate();
  return (
    <>
      <div className="holder-account-list-page">
        <div className="holder-top-page-layout">
          <div className="holder-row-top-page">
            <div className="holder-info-page">
              <Breadcrumb
                className="breadcrumbs"
                items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("acounts.accountinfo.title") }]}
              />
              <div className="holder-descript-page">
                <h3>{t("acounts.accountinfo.title")}</h3>
              </div>
            </div>
            <div className="holder-acction-page">
              <div className="holder-button">
                <Button
                  onClick={() => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.AccountInfo)}
                  type="default"
                  className="btn-print"
                  icon={<i className="icon-new-item"></i>}
                >
                  ایجاد حساب جدید
                </Button>
              </div>
            </div>
          </div>
          <Content className="bg-container">
            <div className="holder-table">
              <Table
                className="tbl-normal"
                columns={[
                  {
                    title: "نام بانک",
                    dataIndex: "name",
                    key: "name",
                  },
                  {
                    title: "شماره حساب بانکی ",
                    dataIndex: "accountnumber",
                    key: "accountnumber",
                  },
                  {
                    title: "شماره کارت",
                    dataIndex: "cardnumber",
                    key: "cardnumber",
                  },
                  {
                    title: "شماره شبا",
                    dataIndex: "shebanumber",
                    key: "shebanumber",
                  },
                  {
                    title: "",
                    dataIndex: "action",
                    key: "action",
                  },
                ]}
                locale={{
                  emptyText: (
                    <>
                      <NotFound text={"رکوردی یافت نشد."} />
                    </>
                  ),
                }}
                pagination={{ position: ["none"] }}
                dataSource={[
                  {
                    key: "01",
                    name: "ملی",
                    accountnumber: "۱۲۳۴۵۶۷۸۹",
                    cardnumber: "۱۲۳۴-۱۲۳۴-۱۲۳۴-۱۲۳۴",
                    shebanumber: "IR85566654654654546464465",
                    action: (
                      <>
                        <Button className="btn-normal">حذف</Button>
                      </>
                    ),
                  },
                  {
                    key: "02",
                    name: "ملی",
                    accountnumber: "۱۲۳۴۵۶۷۸۹",
                    cardnumber: "۱۲۳۴-۱۲۳۴-۱۲۳۴-۱۲۳۴",
                    shebanumber: "IR85566654654654546464465",
                    action: (
                      <>
                        <Button className="btn-normal">حذف</Button>
                      </>
                    ),
                  },
                ]}
              ></Table>
            </div>
          </Content>
        </div>
      </div>
    </>
  );
};

export default Accountlist;
